module.exports = __webpack_public_path__ + "media/Michael Jackson - Speechless.d427a615.mp3";